
import React, { Component } from 'react';

import {VolOff, CamOff, VolOn, MicOff, MicOn, Call, Cam} from './Icons'
import Streams from './Streams';
import Tracks from './Tracks';

class CallScreen extends Component {

  render() {
    console.log("Render call screen");

    return (
      <div className="callscreen" style={this.props.style}>
        <div className="options">
          <div className={"roundIcon muteRemote" + (this.props.muteRemote ? ' active' : '')}
            onClick={() => this.props.onMuteRemote()}>
            <div>
              {this.props.muteRemote && <VolOff />}
              {!this.props.muteRemote && <VolOn />}
            </div>
          </div>
          <div className={"roundIcon muteLocal" + (this.props.muteLocal ? ' active' : '')}
            onClick={() => this.props.onMuteLocal()}>
            <div>
              {this.props.muteLocal && <MicOff />}
              {!this.props.muteLocal && <MicOn />}
            </div>
          </div>
          <div className="roundIcon endCall"
            onClick={() => this.props.onStopCall()}>
            <div>
              <Call />
            </div>
          </div>
          <div className={"roundIcon disableCam" + (this.props.disableCam ? ' active' : '')}
            onClick={() => this.props.onDisableCam()}>
            <div>
              {this.props.disableCam && <CamOff />}
              {!this.props.disableCam && <Cam />}
            </div>
          </div>
          {/*}
          <div className="roundIcon switchCam"
            onClick={() => this.props.onSwitchCam()}>
            <div>
              <SwitchCam />
            </div>
          </div>*/}
        </div>
        <div className="camstreams">
          {!this.props.group && <Streams
            onError={(kind) => this.props.onError(kind)}
            onStreamsRunning={() => this.props.onStreamsRunning()}
            remoteStream={this.props.remote.stream}
            localStream={this.props.local.stream}
            audioDevices={this.props.audioDevices}
            videoDevices={this.props.videoDevices}
            callStatus={this.props.callStatus}
          />}
          {this.props.group && <Tracks
            conversation={{
              tracks: this.props.tracks || [],
              room: this.props.room,
              jitsiController: this.props.jitsiController
            }}
            onError={(kind) => this.props.onError(kind)}
            onStreamsRunning={() => this.props.onStreamsRunning()}
            trackCount={(this.props.tracks || []).length}
            muteRemote={this.props.muteRemote}
            callStatus={this.props.callStatus}
          />}
        </div>
      </div>
    );
  }
};

export default CallScreen;


// WEBPACK FOOTER //
// ./src/shared/CallScreen.js


// WEBPACK FOOTER //
// ./src/shared/CallScreen.js